import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import InputForm from "../../../components/input-form";
import Modal from "../../../components/modal";
import SelectComponent from "../../../components/select-component";

const visibilityOptions = [
    {value: "private", label: "Privado"},
    {value: "shared", label: "Compartilhado"},
];

const BoardFormModal = ({isOpen, board, users, onClose, onSave, isSaving = false}) => {
    const [name, setName] = useState("");
    const [visibility, setVisibility] = useState(visibilityOptions[0]);
    const [sharedUsers, setSharedUsers] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        setName(board?.name ?? "");
        setVisibility(visibilityOptions.find(option => option.value === board?.visibility) ?? visibilityOptions[0]);
        setSharedUsers(board?.sharedUsers ?? []);
        setError("");
    }, [board, isOpen]);

    const submit = event => {
        event.preventDefault();
        if (!name.trim()) {
            setError("Informe o nome do quadro.");
            return;
        }
        if (visibility.value === "shared" && sharedUsers.length === 0) {
            setError("Selecione ao menos um usuário para compartilhar o quadro.");
            return;
        }
        onSave({name: name.trim(), visibility: visibility.value, sharedUsers: visibility.value === "shared" ? sharedUsers : []});
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={board ? "Editar quadro" : "Novo quadro"} className="w-11/12 max-w-xl" isCloseClick={false} overflow>
            <form onSubmit={submit}>
                <div className="grid gap-5 p-5">
                    <InputForm id="board-name" name="name" label="Nome do quadro" value={name} onChange={({target}) => { setName(target.value); setError(""); }} col="w-full" autoFocus />
                    <SelectComponent instanceId="board-visibility" label="Visibilidade" options={visibilityOptions} value={visibility} onChange={value => { setVisibility(value ?? visibilityOptions[0]); setError(""); }} col="w-full" isClearable={false} />
                    {visibility.value === "shared" && (
                        <SelectComponent instanceId="board-shared-users" label="Compartilhar com" options={users} value={sharedUsers} onChange={value => { setSharedUsers(value ?? []); setError(""); }} col="w-full" isMulti />
                    )}
                    {error && <p className="text-sm font-medium text-red-600">{error}</p>}
                </div>
                <div className="flex justify-end gap-2 px-3 py-3 border-t border-gray-300 bg-[#F2F2F2] rounded-b-lg">
                    <Button type="submit" target="success" disabled={isSaving}>{isSaving ? "Salvando..." : "Salvar"}</Button>
                </div>
            </form>
        </Modal>
    );
};

export default BoardFormModal;
